// extracted by mini-css-extract-plugin
export var fadeInOut = "_1f-3";
export var icon = "_1f-4";
export var savedIndicator = "_1f-2";
export var savingIndicator = "_1f-0";
export var spin = "_1f-1";